module.exports = __webpack_public_path__ + "img/x.eebeed03.svg";